import parseNumber, { E164Number, CountryCode, NumberFormat } from 'libphonenumber-js';
import { useMemo } from 'react';

export type { E164Number, CountryCode, NumberFormat };

const DEFAULT_COUNTRY_CODE: CountryCode = 'US';

export const usePhoneFormat = (
  input: E164Number,
  countryCode: CountryCode = DEFAULT_COUNTRY_CODE,
  format?: NumberFormat,
) => {
  const phone = useMemo(() => parseNumber(input), [input]);

  // Return the original number if it fails to be parsed and recognized as a possible number
  if (!phone || !phone.isPossible()) {
    return input;
  }

  // Use the national-specific format if the number is valid and the detected locale is the same country
  const fallbackFormat: NumberFormat =
    phone.isValid() && phone.country === countryCode ? 'NATIONAL' : 'INTERNATIONAL';

  return phone.format(format ?? fallbackFormat);
};
